import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import '../styles/PageSidebar.css';
import useDynamicPath from '../hooks/useDynamicPath';
import constants from '../constants.json' assert { type: 'json' };
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

const SidebarCategory = ({ title, isExpanded = false, children = null, handle = null }) => {
    const [expanded, setExpanded] = useState(isExpanded);
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    const toggleExpanded = useCallback(() => {
        setExpanded((prev) => !prev);
    }, []);
    return (
        <div
            className={'page-sidebar--category'}
        >
            <button
                className={'page-sidebar--category-expand-button'}
                onClick={toggleExpanded}
                onKeyDown={toggleExpanded}
            >
                <div
                    className={'page-sidebar--category-header'}>
                    <div
                        className={'page-sidebar--category-title'}>
                        {handle ? (
                            <Link
                                to={`${collectionPath[0].pathBeforeParams}/${handle}`}>
                                {title}
                            </Link>
                        ) : (
                            <span>{title}</span>
                        )}
                    </div>
                    {children && (
                        <span
                            className={'page-sidebar--category-icon'}
                        >
                            {expanded ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                        </span>
                    )}
                </div>
            </button>
            {expanded && children && (
                <ul
                    className={'page-sidebar--list'}
                >
                    {children}
                </ul>
            )}
        </div>
    );
};

SidebarCategory.propTypes = {
    title: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool,
    children: PropTypes.node,
    handle: PropTypes.string,
};

export default SidebarCategory;